import {
  BadgeCheck,
  Briefcase,
  ClipboardCheck,
  Compass,
  FileText,
  FolderCheck,
  GraduationCap,
  Luggage,
  Plane,
  PoundSterling,
} from "lucide-react";

export const SERVICE_ICON_MAP = {
  BadgeCheck,
  Briefcase,
  ClipboardCheck,
  Compass,
  FileText,
  FolderCheck,
  GraduationCap,
  Luggage,
  Plane,
  PoundSterling,
} as const;
